export interface Testimonial {
  quote: string
  name: string
  role: string
  photo: string
  alt: string
}

export const testimonialsSerie1: Testimonial[] = [
  {
    quote:
      'Mon premier parcours mené jusqu’à la séance 10. Au bilan de clôture, ma cliente a énuméré elle-même ce qu’elle avait obtenu, sans que j’aie à le lui souffler. Je n’avais jamais entendu ça en trois ans de pratique.',
    name: 'Claire M.',
    role: 'Coach professionnelle, certifiée RNCP',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/fec70ed2-62e2-4808-b59a-8c3cab914a46.jpg',
    alt: 'Portrait de Claire M., coach professionnelle',
  },
  {
    quote:
      'La quatrième séance, c’était mon mur. J’ai annoncé le passage de phase au bilan de la séance 3, comme le tome 3 le propose. Elle est arrivée en sachant où on en était, et le parcours a continué.',
    name: 'Sylvie R.',
    role: 'Coach professionnelle, certifiée ICF',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/487045d9-2883-4ec3-bbe0-97e8fe91bd1b.jpg',
    alt: 'Portrait de Sylvie R., coach professionnelle',
  },
  {
    quote:
      'Je présente un parcours, plus des séances. Je n’ai plus l’impression de vendre quelque chose : j’explique ce qu’il contient et où on va. Le doute sur ma légitimité est retombé de lui-même.',
    name: 'Thomas L.',
    role: 'Coach professionnel, certifié RNCP',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/19a79e72-eafc-4b7b-840c-c8137b8572fa.jpg',
    alt: 'Portrait de Thomas L., coach professionnel',
  },
]

export const testimonialsSerie2: Testimonial[] = [
  {
    quote:
      'La Séance Zéro minutée a changé mes premiers rendez-vous. Soixante-quinze minutes, le Livret d’accueil, la feuille de route co-construite. Le client repart avec quelque chose dans les mains dès le premier jour.',
    name: 'Amina B.',
    role: 'Coach certifiée RNCP',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a5779fbd-140a-499b-a1a1-40d09e34ef41.jpg',
    alt: 'Portrait d’Amina B., coach certifiée',
  },
  {
    quote:
      'Le Point d’Ancrage relu au début de chaque séance, et le Carnet du coaché entre nos mains. Mes clients voient le chemin parcouru sans que j’aie besoin de le leur prouver.',
    name: 'Léa D.',
    role: 'Coach, 2e année',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/0fa2997b-0106-4c59-aee1-b5d80c8198e4.jpg',
    alt: 'Portrait de Léa D., coach',
  },
  {
    quote:
      'La fiche Signaux d’orientation m’a servi deux fois en six mois : j’ai su nommer ce qui dépassait le coaching et orienter proprement. C’est là que j’ai senti la différence entre un cadre et une bonne intention.',
    name: 'Pierre H.',
    role: 'Coach professionnel, supervisé',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/b0045c55-154a-460e-8832-a6a7d8a19153.jpg',
    alt: 'Portrait de Pierre H., coach professionnel',
  },
]
